import pallette from './pallette';

type PanelsTheme = {
    colors: {
        accordion: {
            background: string;
            border: string;
        };
        card: {
            text: string;
            background: string;
            border: string;
            boxShadow: string;
            contrast: {
                text: string;
                background: string;
                border: string;
            };
            error: {
                text: string;
                background: string;
                border: string;
            };
        };
        drawer: {
            text: string;
            background: string;
            contrast: {
                text: string;
                background: string;
            };
        };
        errorCard: {
            text: string;
            background: string;
            border: string;
        };
    };
};

const { transparent, white, lightBlue, darkBlue, midRed } = pallette;

const panels: PanelsTheme = {
    colors: {
        accordion: {
            background: lightBlue,
            border: lightBlue,
        },
        card: {
            text: white,
            background: lightBlue,
            border: lightBlue,
            boxShadow: '0 12px 24px rgba(0,0,0,.08)',
            contrast: {
                text: white,
                background: darkBlue,
                border: darkBlue,
            },
            error: {
                text: white,
                background: midRed,
                border: midRed,
            },
        },
        drawer: {
            text: white,
            background: darkBlue,
            contrast: {
                text: white,
                background: lightBlue,
            },
        },
        errorCard: {
            text: white,
            background: transparent,
            border: midRed,
        },
    },
};

export default panels;
